import PatientListLayer from './PatientListLayer'
import Repository from '../Repository'

export default PatientListLayer
export const repository = new Repository()
